/**
 * KashIO Core EXT r.1.0.0.a
 * KashIO Core API-EXT Release 1.0.0.alpha
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import {
    HttpClient, HttpHeaders,
    HttpResponse, HttpEvent, HttpParams
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Notification } from '../_models/notification.interface';
import { NotificationList, NotificationReportList } from '../_models/index';

import { AppConfig } from '../_helpers/appconfig.service';
import { CustomHttpUrlEncodingCodec } from '../encoder';

@Injectable()
export class NotificationService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

    httpOptions: any;

    constructor
        (
            protected httpClient: HttpClient
        ) {

    }//end const

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * create_notification
     * Create a Notification
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createNotification(body: Notification, observe?: 'body', reportProgress?: boolean): Observable<Notification>;
    public createNotification(body: Notification, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Notification>>;
    public createNotification(body: Notification, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Notification>>;
    public createNotification(body: Notification, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createNotification.');
        }


        return this.httpClient.post<Notification>(`${this._kcmssvcURL}/notifications`,
            body,
            {
                observe: 'response',
            }
        );
    }



    public updateNotification(publicId: string, observe: any = 'body'): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter public Id was null or undefined when calling update Notification.');
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');


        return this.httpClient.patch(`${this._kcmssvcURL}/notifications/${encodeURIComponent(String(publicId))}`, observe, { observe: 'response', headers: headers })
            .pipe(map(response => {
                return response;
            }, err => {
                throw err;
            }));

    } // End

    /**
     * get_notification
     * Get a Notification
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNotification(publicId: string, observe?: 'body', reportProgress?: boolean): Observable<Notification>;
    public getNotification(publicId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Notification>>;
    public getNotification(publicId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Notification>>;
    public getNotification(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getNotification.');
        }



        return this.httpClient.get<Notification>(`${this._kcmssvcURL}/notifications/${encodeURIComponent(String(publicId))}`,
            {

            }
        );
    }
    
    getNotificationReportList(customerId: string, status: string, type: string,from_date?: string, to_date?: string,limit?: string, start?: number, search?: string, search_by?: string){
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling getInvoiceList.');
        }
        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (customerId !== undefined && customerId !== null && customerId.toString() !== '') {
            queryParameters = queryParameters.set('customer_public_id', <any>customerId);
        }
        if (status !== undefined && status !== null && status.toString() !== '') {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (type !== undefined && type !== null && type.toString() !== '') {
            queryParameters = queryParameters.set('type', <any>type);
        }
        if ( from_date !== undefined && from_date !== null && from_date.toString() !== '') {
            queryParameters = queryParameters.set('from_date', <any> from_date);
        }
        if ( to_date !== undefined && to_date !== null && to_date.toString() !== '') {
            queryParameters = queryParameters.set('to_date', <any> to_date);
        }
        if (limit !== undefined && limit !== null && limit.toString() !== '') {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (start !== undefined && start !== null && start.toString() !== '') {
            queryParameters = queryParameters.set('start', <any>start);
        }
        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if(search_by == "scheduled"){
            queryParameters = queryParameters.set('search_by', 'SCHEDULED');
        }
        return this.httpClient.get<NotificationReportList>(`${this._kcmssvcURL}/notifications`,
            {
                params: queryParameters
                ,withCredentials: null,
                observe: 'body',
                reportProgress: false
            }
        );
    }
    getNotificationProperties(publicId: string) {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling notification properties.');
        }
        return this.httpClient.get(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/notification.properties`).toPromise();
    }
    
    getNotificationServicesConfiguration(publicId: string) {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling notification services configuration.');
        }

        return this.httpClient.get(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/notification_services.configuration`).toPromise();
    }
}//end class
